function initKeyIngredients(container = document) {
  // 1. Initialize Slider
  const sliderElement = container.querySelector('#ingredients-slider');
  
  if (sliderElement) {
    // Count how many ingredients there are
    const slideCount = sliderElement.querySelectorAll('.splide__slide').length;
    
    // Set columns to 3, 2, or 1 based on the count (max 3)
    const desktopColumns = slideCount < 3 ? slideCount : 3;

    // Destroy existing instance if it exists (helps prevent duplicate instances in the editor)
    if (sliderElement.splide) {
      sliderElement.splide.destroy();
    }

    const splideInstance = new Splide(sliderElement, {
      perPage: desktopColumns,
      perMove: 1,
      gap: 0, // No gap for full bleed edge-to-edge
      pagination: false,
      arrows: false,
      breakpoints: {
        767: {
          perPage: 1,
          perMove: 1,
          pagination: true, // Show dots on mobile
          padding: 0, // Remove side padding to ensure flush images
        },
      },
    });
    
    splideInstance.mount();
    sliderElement.splide = splideInstance; // Store reference
  }

  // 2. Handle Flip Cards
  const toggleButtons = container.querySelectorAll('.flipper-toggle');

  toggleButtons.forEach(function (toggleButton) {
    // Remove existing listener to prevent duplicates during editing
    const newButton = toggleButton.cloneNode(true);
    toggleButton.parentNode.replaceChild(newButton, toggleButton);

    newButton.addEventListener('click', function (e) {
      e.stopPropagation(); // Prevent event from bubbling up to Splide slider

      const flipperCard = this.closest('.flipper-card');
      const frontSide = flipperCard.querySelector('.flipper-front');
      const backSide = flipperCard.querySelector('.flipper-back');
      const frontButton = flipperCard.querySelector('.btn-about');
      const backButton = flipperCard.querySelector('.flip-card-btn-turn-to-front');

      // Toggle flip state
      const isCurrentlyFlipped = flipperCard.classList.contains('flipper-is-flipped');
      flipperCard.classList.toggle('flipper-is-flipped');

      if (isCurrentlyFlipped) {
        // Flipping to front
        frontSide.removeAttribute('aria-hidden');
        backSide.setAttribute('aria-hidden', 'true');
        frontButton.removeAttribute('tabindex');
        backButton.setAttribute('tabindex', '-1');
        frontButton.focus();
      } else {
        // Flipping to back
        frontSide.setAttribute('aria-hidden', 'true');
        backSide.removeAttribute('aria-hidden');
        frontButton.setAttribute('tabindex', '-1');
        backButton.removeAttribute('tabindex');
        backButton.focus();
      }

      // Update ARIA live regions
      frontSide.setAttribute('aria-live', isCurrentlyFlipped ? 'polite' : 'off');
      backSide.setAttribute('aria-live', isCurrentlyFlipped ? 'off' : 'polite');
    });
  });

  // 3. Add keyboard navigation for Accessibility
  // We attach this to the document, but ensure it only triggers relevant cards
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') {
      const flippedCards = document.querySelectorAll('.flipper-card.flipper-is-flipped');
      flippedCards.forEach((card) => {
        const backButton = card.querySelector('.flip-card-btn-turn-to-front');
        if (backButton) {
          backButton.click();
        }
      });
    }
  });
}

// Run on normal initial page load
document.addEventListener('DOMContentLoaded', function () {
  initKeyIngredients();
});

// Run when the section is re-rendered inside the Shopify Theme Editor
document.addEventListener('shopify:section:load', function (event) {
  // Only re-initialize if the section being loaded is our key ingredients section
  if (event.target.classList.contains('key-ingredients-section')) {
    initKeyIngredients(event.target);
  }
});